var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navigation'),_c('carousel'),_c('keycopy'),_c('keycopy-gallery'),_c('personal-training'),_c('group-activities'),_c('team'),_c('prices'),_c('contacts'),_c('gallery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }